import request from '@/utils/request'

export function faqData(params) {
    return request({
      url: '/content/faqData',
      method: 'get',
      params
    })
  }
  